var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('h1',[_vm._v("Welcome")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }